import {
  FloatingFormItem,
  Group,
  InputDate,
  UserAvatar,
} from '@/components/_common';
import { useUpdateEstimatedDateWorkOrderComplement } from '@/core/domain/workorder/WorkOrdersComplements/WorkOrdersComplements.hooks';
import { WorkOrderUpdateEstimatedDateFormValues } from '@/core/domain/workorder/WorkOrdersComplements/WorkOrdersComplements.types';
import { useDefaultEmptyFieldError, useDisclosure } from '@/hooks';
import { DateTimeFormat } from '@/utils/moment';
import { Button, Form, Input, Modal } from 'antd';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';

import { useWorkorderDetailContext } from '../../../WorkorderDetailProvider';

import './style.less';
import moment from 'moment';
import useSession from '@/hooks/useSession';
import { useEmployee } from '@/core/domain/enterprise/Employees/Employees.hooks';
import Authorities from '@/types/Authority';
import { hasPermissions } from '@/utils/functions/hasPermissions';

type Props = {
  disabled?: boolean;
};

const ComplementEstimatedLeaveDateField: React.FC<Props> = ({ disabled }) => {
  const {
    workorder: { data: workorder },
    complement: { data: complement },
  } = useWorkorderDetailContext();

  const intl = useIntl();
  const [modalOpen, modalAction] = useDisclosure();
  const formInstance = Form.useFormInstance();
  const estimatedLeaveDate = Form.useWatch('estimatedLeaveDate', formInstance);
  const [form] = Form.useForm<WorkOrderUpdateEstimatedDateFormValues>();
  const ruleRequired = useDefaultEmptyFieldError();
  const updateEstimatedDate = useUpdateEstimatedDateWorkOrderComplement();

  const userData = useSession();

  const { data } = useEmployee(userData?.employeeId);

  useEffect(() => {
    if (modalOpen) {
      form.setFieldsValue({
        estimatedLeaveDateModal: estimatedLeaveDate,
        reasonModal: complement?.reasonEstimatedLeaveDate || '',
      });
    }
  }, [estimatedLeaveDate, modalOpen]);

  async function handleSubmit() {
    try {
      const values = await form.validateFields();

      if (workorder?.id && complement?.id) {
        await updateEstimatedDate.mutateAsync({
          workorderId: workorder?.id,
          complementId: complement?.id,
          estimatedLeaveDate:
            values.estimatedLeaveDateModal.format(DateTimeFormat),
          reason: values.reasonModal,
        });

        formInstance.setFieldValue(
          'estimatedLeaveDate',
          values.estimatedLeaveDateModal,
        );

        handleCancel();
      }
    } catch {}
  }

  function handleCancel() {
    form.resetFields();
    modalAction.close();
  }

  return (
    <>
      <Group className="complement-estimated-leave-date">
        <FloatingFormItem
          name="estimatedLeaveDate"
          label={intl.formatMessage({
            id: 'workOrders.domain.complements.estimatedLeaveDate',
          })}
          rules={[
            {
              required: !hasPermissions([
                Authorities.MOVIMENTATION_WORKORDER_ALLOW_EMPTY_ESTIMATED_LEAVE_DATE,
              ]),
            },
          ]}
        >
          <InputDate disabled showTime />
        </FloatingFormItem>

        <Button
          type="primary"
          size="large"
          disabled={disabled}
          onClick={modalAction.open}
        >
          Alterar
        </Button>
      </Group>

      <Modal
        open={modalOpen}
        onCancel={handleCancel}
        title="Alteração de saída prevista"
        okText="Salvar"
        onOk={handleSubmit}
        confirmLoading={updateEstimatedDate.isLoading}
        destroyOnClose
      >
        <Form form={form}>
          <FloatingFormItem
            name="estimatedLeaveDateModal"
            label="Saída prevista"
            rules={[ruleRequired]}
            initialValue={moment()}
          >
            <InputDate showTime />
          </FloatingFormItem>

          <FloatingFormItem
            name="reasonModal"
            label="Mótivo da alteração"
            rules={[ruleRequired]}
          >
            <Input.TextArea rows={4} />
          </FloatingFormItem>

          <Group gap={10}>
            <UserAvatar gender={data?.gender} picture={data?.photo} />
            <div>
              <div>{data?.name}</div>
            </div>
          </Group>
        </Form>
      </Modal>
    </>
  );
};

export default ComplementEstimatedLeaveDateField;
